import { useCallback, useEffect } from 'react';
import {
  useLocationLegacy as useLocation,
  useNavigateLegacy as useNavigate,
} from '@leagueplatform/routing';

export const useConditionalNavigation = () => {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();

  const navigateTo = useCallback(
    (path, replace = false) => {
      const currentFullPath = pathname + search;
      if (currentFullPath !== path) {
        navigate(path, { replace });
      }
    },
    [navigate, pathname, search],
  );

  useEffect(() => {
    const normalizedPathname = pathname.replace(/\/$/, '');
    if (
      normalizedPathname === '/health-journey' ||
      normalizedPathname.startsWith('/health-journey/')
    ) {
      const newPathname = normalizedPathname.replace(
        /^\/health-journey(\/.*)?$/,
        '/messages$1',
      );
      navigateTo(newPathname + search, true);
    }
  }, [pathname, search, navigateTo]);
};
